import React from 'react';
import { Link } from 'react-router-dom';

const EditCurrentStock = () => {
  return (
    <div className="page-content">
      <div className="custom-card patients-head">
        <h5 className="fw-normal custom_py-3 px-2 text-start mb-2 card-title">
          Edit Current Stock
          <Link to="/current-stock" className="btn btn-sm btn-warning float-end">
            <i className="fal fa-long-arrow-left"></i> Back
          </Link>
        </h5>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <p>Edit Current Stock functionality is under development.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCurrentStock;
